import { createContext, useContext } from 'react';

import usePersistentState from '../use-persistent-state';

// Single source of truth for the demo-mode name blur. Apply as
// `style={isBlurred ? BLUR_STYLE : undefined}` at every name-render site.
export const BLUR_STYLE: React.CSSProperties = { filter: 'blur(6px)', userSelect: 'none' };

interface IDemoBlurContext {
  // Single "blur names for demo" switch shared by Portfolio Performance,
  // Portfolio Management and Account Management. Persisted to localStorage so
  // it holds across pages and reloads - one toggle, everywhere.
  isNamesBlurred: boolean;
  setIsNamesBlurred: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DemoBlurContext = createContext<IDemoBlurContext>({
  isNamesBlurred: false,
  setIsNamesBlurred: () => {},
});

export const DemoBlurProvider = ({ children }: { children: React.ReactNode }) => {
  const [isNamesBlurred, setIsNamesBlurred] = usePersistentState<boolean>(
    ['DEMO_MODE'],
    'isNamesBlurred',
    false,
  );

  return (
    <DemoBlurContext.Provider value={{ isNamesBlurred, setIsNamesBlurred }}>
      {children}
    </DemoBlurContext.Provider>
  );
};

export const useDemoBlur = () => useContext(DemoBlurContext);
